import React from 'react';
import { useIntl } from 'react-intl';
import { FlexBox } from '../../FlexBox';
import { Typography } from '@mui/material';
import CircleRoundedIcon from '@mui/icons-material/CircleRounded';

/**
 * A value as a coloured status.
 *
 * The wording is the value read as a message key, which is how every caller has always used it.
 * `label` overrides that for the callers whose vocabulary carries its own wording.
 */
const StatusInfo = function StatusInfo({
  value,
  optionsColors,
  fontSize,
  label = null,
}) {
  const intl = useIntl();
  const wording = label
    ? (intl.messages[label] ?? label)
    : intl.messages[value?.toUpperCase()];

  return !value && !wording && optionsColors[value?.toUpperCase()] ? (
    <div />
  ) : (
    <FlexBox alignItems="center">
      <CircleRoundedIcon
        sx={{ color: optionsColors[value?.toUpperCase()] || 'greys.darker' }}
      />
      <Typography
        variant="body2"
        sx={{ fontWeight: 'bold', ml: '3%', fontSize }}
        title={wording}
      >
        {wording}
      </Typography>
    </FlexBox>
  );
};
export default StatusInfo;
